module.exports = __webpack_public_path__ + "img/a-004.prt.26f50587.jpg";